module.exports = __webpack_public_path__ + "static/img/center-bg.dca0568.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/center-bg.png
// module id = GfuL
// module chunks = 1